module.exports = __webpack_public_path__ + "static/media/1_create.cf73b26d.png";